/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { getIsPassportUserLoggedIn } from '../../../Checkout/ducks/Global/Global-Selectors';
import { getFeatureFlags } from '../App/App-Selectors';
import { getPassportItem } from '../Cart/Cart-Selectors';
// ../MfeCheckout/ducks/Cart/Cart-Selectors

export const getOrderId = (state) => state?.order?.orderId || '';

export const getPaymentMethod = (state) => state?.checkout?.payment?.paymentForm?.paymentMethod;

export const getPassportOrderItemId = (state) => {
    const passportItem = getPassportItem(state);
    if (passportItem.length > 0) {
        return passportItem[0].cartItemId;
    }
    return '';
};

export const getPassportSubscriptionStatus = (state) => {
    const passportItem = getPassportItem(state);
    if (passportItem.length > 0) {
        return true;
    }
    return false;
};

export const getGiftCardDetails = (state) => state.mfeCheckout?.cart?.appliedGiftCards || [];
export const getIfGiftCardApplied = (state) => {
    if (state.mfeCheckout?.cart?.appliedGiftCards?.length > 0) {
        return true;
    }
    return false;
};

export const getPassportData = (state) => state?.passport?.passportData;

export const getPassportSideBarStatus = (state) => state?.passport?.passportSideBarStatus;

export const getPassportCampaignData = (state) => state?.passport?.passportCampaign;

export const getStatusOfPassportApplyRmGC = (state) => state?.passport?.showPassportConsentToRmGC;

export const getPassportSignInData = (state) => state?.passport?.passportSignIn;

export const getPassportError = (state) => state?.passport?.error;

export const getPassportABData = (state) => state?.passport?.passportABData;

export const getIsPassportRenewalAllowed = (state) => {
    const userDetails = state?.member?.profile;
    if (userDetails?.userRole === 'P'
        && userDetails?.passportStartDate
        && userDetails?.passportEndDate) {
        const endDate = new Date(userDetails.passportEndDate).getTime();
        const ninetyDaysFromNow = new Date(new Date().setDate(new Date().getDate() + 90));
        if (endDate > ninetyDaysFromNow) {
            return false;
        }
    }
    return true;
};

export const getPassportMemberProfile = (state) => state?.member?.profile;

export const getPassportActiveMember = (state) => {
    const isPassportUser = getIsPassportUserLoggedIn(state);
    const passportSignInData = getPassportSignInData(state);
    if (
        passportSignInData?.type === 'expiringPassportMembership'
        && passportSignInData?.productPageMessage
    ) return false;
    if (isPassportUser) return true;
    return false;
};
